'use strict';

//ーーーーーーーーーーーーーーーーーーーーーーー
// headerメニューに関係のあるjsはproduct-detail.jsにも手動で反映する必要あり
//ーーーーーーーーーーーーーーーーーーーーーーー




// LINK ROLLOVER（常に同じ方向・アウトは瞬時リセット）
document.querySelectorAll('.link__rollover').forEach(function (el) {
  var link = el.closest('a');
  if (!link) return; // nullガード追加
  link.addEventListener('mouseenter', function () {
    el.classList.remove('is-reset');
    el.classList.add('is-enter');
  });
  link.addEventListener('mouseleave', function () {
    el.classList.remove('is-enter');
    el.classList.add('is-reset');
  });
});

// MENU
document.querySelectorAll('.js-menu').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.toggle('is-menu');
    document.body.classList.remove('is-shop');

    // 1299px以下: .header__nav__product をスライドトグル
    if (window.innerWidth <= 1299) {
      $('.js-menu').toggleClass('is-active');
      $('.header__nav__product').slideToggle(300);
    }
  });
});

// MENU - SHOP
document.querySelectorAll('.js-shop').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.toggle('is-shop');
    document.body.classList.remove('is-menu');

    // 1299px以下: .header__nav__product をスライドトグル
    if (window.innerWidth <= 1299) {
      $('.js-shop').toggleClass('is-active');
      $('.header__nav__shop').slideToggle(300);
    }
  });
});

// MENU - FOOTER
document.querySelectorAll('.js-footer').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    //1300px以上はヘッダーの動作
    if (window.innerWidth >= 1300) {
      document.body.classList.toggle('is-shop');
      document.body.classList.remove('is-menu');
      document.body.classList.remove('is-footer');
    } else {
      document.body.classList.toggle('is-footer');
    }
  });
});

// MENU - OVERLAY
document.querySelectorAll('.header__nav__overlay').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.remove('is-shop');
    document.body.classList.remove('is-menu');
  });
});

// MENU - SP
document.querySelectorAll('.js-spmenu').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    document.body.classList.toggle('is-opened');
    document.querySelectorAll('.link__rollover').forEach(function (el) {
      el.classList.remove('is-reset');
    });
  });
});

//ANKER LINK
var anchorLinks = document.querySelectorAll('a[href^="#"]');
var anchorLinksArr = Array.prototype.slice.call(anchorLinks);
anchorLinksArr.forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    var targetId = link.hash;
    var targetElement = document.querySelector(targetId);
    var header = document.querySelector('.header');
    var headerHeight = header.clientHeight;
    var targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - headerHeight;
    //		const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: "smooth"
    });
  });
});

// FADE UP on scroll
var fadeUpObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show');
      fadeUpObserver.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.1
});
document.querySelectorAll('.js-fadeup').forEach(function (el) {
  fadeUpObserver.observe(el);
});

//TEXT ANIMATION
var textObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-active');
      textObserver.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.1
});
document.querySelectorAll('.js-text').forEach(function (el) {
  textObserver.observe(el);
});

// SCROLL CLASS
window.addEventListener('scroll', function () {
  if (window.scrollY >= 150) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var find = new Swiper(".bar", {
    loop: true,
    slidesPerView: "auto",
    speed: 10000,
    allowTouchMove: false,
    simulateTouch: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    }
  });

  if (document.querySelector(".marquee")) {
    var _find = new Swiper(".marquee", {
      loop: true,
      slidesPerView: "auto",
      speed: 20000,
      allowTouchMove: false,
      simulateTouch: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      }
    });
  }
});